import GameFrame from '@/src/components/Player/GameFrame/GameFrame'

export default GameFrame
